import { Chip } from "@mui/material";
import { useLocalization } from "@fluent/react";

type ProjectStatusCode = "D" | "I" | "H" | "F" | "C" | "";
type ExtendedProjectStatusCode = ProjectStatusCode | "DRAFT";

export const ProjectStatusChip = ({ status }: { status: ExtendedProjectStatusCode }) => {
    const { l10n } = useLocalization();

    switch (status) {
        case "D":
        case "DRAFT":
            return (
                <Chip
                    size="small"
                    label={l10n.getString("project-status-d", null, "Szkic")}
                    color="info"
                    variant="outlined"
                />
            );
        case "I":
            return (
                <Chip
                    size="small"
                    label={l10n.getString("project-status-i", null, "W trakcie")}
                    color="info"
                />
            );
        case "H":
            return (
                <Chip
                    size="small"
                    label={l10n.getString("project-status-h", null, "Wstrzymany")}
                    color="primary"
                    variant="outlined"
                />
            );
        case "F":
            return (
                <Chip
                    size="small"
                    label={l10n.getString("project-status-f", null, "Zakończony")}
                    color="success"
                />
            );
        case "C":
            return (
                <Chip
                    size="small"
                    label={l10n.getString("project-status-c", null, "Anulowany")}
                    color="error"
                />
            );
        default:
            return <span />;
    }
};
